import React, { PureComponent, Suspense } from 'react'
import { BrowserRouterProps, RouterProvider } from 'react-router-dom'

import Loader from './Components/Loader'

import getAppRouter from './Configurations/getAppRouter'

export interface IAppRouterProps extends BrowserRouterProps { }

let router: ReturnType<typeof getAppRouter> | undefined

export default class AppRouter extends PureComponent<IAppRouterProps> {
  render() {
    if (!router) {
      router = getAppRouter()
    }

    return (
      <Suspense fallback={<Loader />}>
        <RouterProvider router={router} />
      </Suspense>
    )
  }
}